<template>
  <transition name="slide-fade">
    <div v-if="!submitted" class="winner-form">
      <h1>Toppen!</h1>
      <div class="divider"></div>
      <p>Bara ett steg kvar: fyll i dina uppgifter nedan och motivera varför just du ska vinna</p>
      <form class="submit-form">
        <input v-model="userdata.name" type="text" name="name" placeholder="Namn" >
        <input v-model="userdata.email" type="email" name="email" placeholder="E-mail" >
        <input v-model="userdata.adress" type="text" placeholder="Adress" >
        <textarea v-model="userdata.motivation" name="motivation" placeholder="Motivering"></textarea>
        <div class="submit-button" @click="submitForm">Delta</div>
        <div class="fine-print">
          <label class="my-checkbox">
            <input v-model="accepted" type="checkbox" name="accept"/>
            <span>Jag godkänner de <a href="static/villkor.html" target="_blank">allmänna villkoren</a>.</span>
          </label>
        </div>
      </form>
    </div>
    <div v-if="submitted" class="winner-form">
      <h1>Tack!</h1>
      <div class="divider"></div>
      <p>Öka dina chanser genom att tävla med fem nya produkter eller genom att dela tävlingen till en vän!</p>
      <div class="share-el">
        <div class="share-button" @click="resetAll">Tävla med ny produkt</div>
        <div class="share-button" @click="shareFacebook">Dela på facebook</div>
      </div>
    </div>
  </transition>
</template>

<script>
import FireDb from '@/api/FireDb.js'
export default {
  name: 'WinnerForm',
  data () {
    return {
      msg: 'Cloetta',
      submitted: false,
      userdata: {
        name: null,
        email: null,
        adress: null,
        motivation: null
      },
      accepted: false
    }
  },
  props: ['codes'],
  methods: {
    submitForm () {
      let err = false
      let what = ''
      if (!this.accepted) {
        err = true
        what = 'Du måste acceptera de allmänna villkoren för att delta i tävlingen.'
      }
      for (var key in this.userdata) {
        if (this.userdata[key] === null) {
          err = true
          what = 'Du måste fylla i alla uppgifter.'
        }
      }
      if (this.userdata.email !== null && !this.validateEmail(this.userdata.email)) {
        err = true
        what = 'Du måste fylla i en korrekt e-postadress.'
      }
      if (!err) {
        //  Submit to firebase here
        let reportRef = FireDb.database().ref('submits/').push()
        reportRef.set({
          user: this.userdata,
          codes: this.codes
        })
        this.submitted = true
      } else {
        alert(what)
      }
    },
    shareFacebook () {
      window.FB.ui({
        method: 'share',
        href: 'https://engodupplevelse.nu'
      }, function (response) {
        console.log(response)
      })
    },
    resetAll () {
      this.$emit('resetall')
    },
    validateEmail (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .winner-form {
    position: relative;
    z-index: 99999;
    font-size: 2.8vh;
  }
  input, textarea {
    font-family: "futura-pt",sans-serif;
    font-size: 2.4vh;
    width: 36vh;
    border: 0;
    margin: 0;
    padding: 2vh;
    box-sizing: border-box;
    height: 8vh;
    margin-bottom: 0.6vh;
    z-index: 1;
    background-color: #ffcf26;
    color: #fff;
    text-transform: uppercase;
    font-weight: bold;
  }
  .my-checkbox input {
    width: 3.6vh;
    height: 3.6vh;
    vertical-align: middle;
  }
  textarea {
    height: 16vh;
    background-color: #ffcf26;
    overflow: auto;
  }
  @media only screen and (max-height: 570px) {
    input, textarea {
      font-size: 18px;
    }
  }
  ::placeholder {
    color: #fff;
  }
  .my-checkbox {
    display: block;
    width: 100%;
  }
  .fine-print {
    color: #000;
    font-size: 1.9vh;
    line-height: 1.7vh;
    max-width: 34vh;
    width: 100%;
    margin: auto;
    margin-top: 1vh;
  }
  .fine-print a {
    color: inherit;
  }
  .submit-form {
    max-width: 50vh;
    margin: auto;
  }
  .submit-button, .share-button {
    display: inline-block;
    width: 36vh;
    border: 0;
    margin: 0;
    padding: 2.3vh;
    text-align: center;
    box-sizing: border-box;
    height: 8vh;
    text-transform: uppercase;
    font-weight: bold;
    background-color: #ffcf26;
    cursor: pointer;
    border-bottom: 0.6vh solid #e5a505;
  }
  .share-el {
    margin-top: 14vh;
  }
  .share-button {
    width: 43vh;
    margin: 1vh;
  }
  h1 {
    font-size: 4.3vh;
    width: 84vw;
    max-width: 500px;
    margin: auto;
    display: block;
    margin-top: 4vh;
    margin-bottom: 1.4vh;
    line-height: 1.1em;
  }
  .divider {
    width: 55vw;
    max-width: 400px;
    height: 1px;
    background-color: #fff;
    margin: auto;
  }
  p {
    width: 72vw;
    max-width: 500px;
    font-size: 2.3vh;
    margin: auto;
    display: block;
    margin-top: 1.8vh;
    line-height: 1.14em;
    margin-bottom: 2.1vh;
  }
  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(-30vh);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/WinnerForm.vue